<template>
  <div class="page_candidate">
    <!-- <div class="navBar">
      <div :class="index == isActive ? 'isActive nav_Item' : 'nav_Item'" v-for="(item,index) in list" :key="index" @click="changeActive(index)">{{ item.name }}</div>
    </div>

    <candidate v-if="isActive==1"/> -->
    <router-view></router-view>
  </div>
</template>
    
<script>
import xz from "@/common";
// import candidate from "./components/candidate.vue";
export default {
  components:{
  },
  data() {
    return {
      list:[{
        name:'快捷回复'
      },{
        name:'候选人画像'
      },{
        name:'招聘管理'
      }],
      isActive:1
    }
  },
  async created() {
    this.$store.commit('setHiddenLeft', true)
  },
  methods: {
    changeActive(index){
      this.isActive = index
    }
  }
}

  </script>
 <style scoped>
html {
  font-size: 10px;
}

.navBar {
  height: 3.125rem;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 5px;
  border-bottom: 1px solid #fdfdfd;
}
.nav_Item {
  height: 24px;
  line-height: 24px;
  padding: 0 15px;
  background: #f2f2f2;
  margin-right: 10px;
}
.isActive {
  background: #19bd92;
  color: #fff;
}
.candidate_info {
  margin-top: 5px;
  font-size: 14px;
  padding: 10px;
  color: #333;
}

</style>
    
 